import { IContainerType } from "../types/IContainerType";
import { TThumbnailPositionEnum } from "../enums/TThumbnailPositionEnum";

export function getThumbnailName(
  carrierName: string,
  containerType: IContainerType,
  position: TThumbnailPositionEnum,
  format: "png" | "jpg" | "webp",
): string {
  return `${carrierName}-${containerType}-th-${position}.${format}`;
}
